import { useQuery } from '@tanstack/react-query'
import { OpalApiResponseDocument } from '../../schema'
import { readExperimental } from './requests/read'
import { readPlan } from '.'

type ReadPlansResponse = OpalApiResponseDocument<
  'ExperimentalReadPlanBFFV1',
  200
>

type UseReadViewsParams = {
  enabled?: boolean
  planId: string
  workspaceUuid: string
}

type UseReadViewsOptions<T = ReadPlansResponse> = UseReadViewsParams & {
  select?: (data: ReadPlansResponse) => T
}

export const useReadPlan = <T = ReadPlansResponse>({
  enabled,
  planId,
  select,
  workspaceUuid,
}: UseReadViewsOptions<T>) => {
  return useQuery({
    enabled,
    queryKey: readPlan.queryKey({
      workspaceUuid,
      resourceId: planId,
      queryParams: null,
    }),
    queryFn: () =>
      readExperimental({
        params: {
          path: {
            plan_id: planId,
            workspace_id: workspaceUuid,
          },
        },
      }),
    select,
  })
}
